import { DateTime } from 'luxon';

export const time = {
  daysUntil: (date?: string) => {
    if (!date) return 0;
    const currentDate = Date.now();
    const timeLeft = Math.round((Date.parse(date) - currentDate) / (1000 * 60 * 60 * 24));
    return timeLeft;
  },
};

export const getDate = (date?: string) => {
  if (!date) return '';
  const dateTime = new Date(date);
  return dateTime.toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
};

export const getDateTime = (date?: string) => {
  if (!date) return {};
  const dateTime = new Date(date);
  return {
    day: dateTime.toLocaleDateString('en-US', { weekday: 'long' }),
    month: dateTime.toLocaleDateString('en-US', { month: 'long' }),
    date: dateTime.toLocaleDateString('en-US', { day: '2-digit' }),
    hour: dateTime.toLocaleTimeString('en-US', { hour: '2-digit' }).slice(0, 2),
    minute: '00',
    timeOfDay: dateTime.toLocaleTimeString('en-US', { hour: '2-digit' }).slice(3),
  };
};

export const getSchoolYear = () => {
  const today = DateTime.now();
  return Number(today.month > 6 ? today.year + 1 : today.year);
};
